import { useEffect, useRef } from 'react'
import { Group, Text } from '@mantine/core'
import TagStringEditor from './TagStringEditor'

export default function EditableTagField({
    label,
    value,
    onChange,
    fieldName,
    editing,
    setEditing,
    onSave,
    roomId,
    readOnly = false,
    canEdit = true
}) {
    const isEditing = editing === fieldName
    const inputRef = useRef(null)

    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus()
        }
    }, [isEditing])

    const handleClick = () => {
        if (canEdit && !readOnly) {
            setEditing(fieldName)
        }
    }

    const handleBlur = () => {
        setEditing(null)
        if (onSave) {
            onSave(fieldName, value)
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === 'Escape') {
            setEditing(null)
            if (onSave) {
                onSave(fieldName, value)
            }
        }
    }

    return (
        <Group gap="xs" align="flex-start" wrap="nowrap">
            <Text size="sm" fw={500} c="dimmed" style={{ minWidth: '100px', flexShrink: 0 }}>
                {label}
            </Text>
            {isEditing && !readOnly ? (
                <TagStringEditor
                    ref={inputRef}
                    roomId={roomId}
                    value={value}
                    onChange={onChange}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                    size="sm"
                    styles={{
                        input: {
                            minHeight: '28px',
                            padding: '4px 8px'
                        }
                    }}
                    style={{ flex: 1 }}
                    placeholder="Enter tags..."
                />
            ) : (
                <Text
                    size="sm"
                    onClick={handleClick}
                    style={{
                        flex: 1,
                        cursor: canEdit && !readOnly ? 'pointer' : 'default',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        transition: 'background-color 0.15s',
                        ...(canEdit && !readOnly && {
                            ':hover': { backgroundColor: 'rgba(255,255,255,0.05)' }
                        })
                    }}
                    onMouseEnter={(e) => {
                        if (canEdit && !readOnly) {
                            e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)'
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (canEdit && !readOnly) {
                            e.currentTarget.style.backgroundColor = 'transparent'
                        }
                    }}
                >
                    {value || <span style={{ opacity: 0.5 }}>Click to edit...</span>}
                </Text>
            )}
        </Group>
    )
}

